// Función para descomprimir datos en el frontend
// Necesitas instalar: npm install pako (para descompresión en el navegador)

import { gunzipSync } from 'fflate';


export class DataDecompressor {
    
    // Función para descomprimir los datos recibidos del backend
    static decompressData(compressedResponse) {
        
        
      // Función para descomprimir los datos recibidos del backend
       try {
            if (!compressedResponse.compressed) {
                return compressedResponse;
            }

          

            // Convertir de base64 a ArrayBuffer
            const binaryString = atob(compressedResponse.data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

          

            // Descomprimir usando fflate
            const decompressedBytes = gunzipSync(bytes);
            
            // Convertir a string
            const decompressed = new TextDecoder('utf-8').decode(decompressedBytes);
            
            // Parsear JSON
            const parsedData = JSON.parse(decompressed);

         

            return parsedData;

        } catch (error) {
            console.error('Error al descomprimir con fflate:', error);
            throw new Error(`Error al descomprimir: ${error.message}`);
        }
    }

   
   
}

